import { Departamento } from './departamento';
import { Parametro } from './parametro';

export class ParametrosFormulario {
  ListaTipoDireccion: Array<Parametro>;
  ListaEstadoCivil: Array<Parametro>;
  ListaGradoInstruccion: Array<Parametro>;
  ListaDepartamento: Array<Departamento>;
  ListaSituacionLaboral: Array<Parametro>;
  ListaRelacion: Array<Parametro>;
  ListaEstados: Array<Parametro>;
}
